/** The fields a person types into. */
const TEXT_FIELDS =
  "textarea, input:not([type]), input[type='text'], input[type='search'], input[type='password'], input[type='email'], input[type='number'], input[type='url'], input[type='tel']";

/**
 * True when a text field under `root` holds something typed (a draft title, a note, a rename): a
 * reload (src/update.ts) or a bare Escape (src/desktop-keys.ts) would throw it away, so neither
 * happens. A field the screen filled in itself counts too; holding still there costs nothing.
 */
export function hasTypedText(root: ParentNode | null | undefined): boolean {
  if (!root || typeof root.querySelectorAll !== "function") return false;
  for (const el of Array.from(root.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>(TEXT_FIELDS))) {
    if (el.value && el.value !== el.defaultValue) return true;
  }
  return false;
}
